// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__2Z8Od","subtitle":"style_subtitle__13UOn"};